var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 63,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 62,
    rx: 9.5,
    stroke: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 18a2.25 2.25 0 0 0-2.25-2.25H52a3 3 0 0 1-6 0h-3.75A2.25 2.25 0 0 0 40 18m18 0v6a2.25 2.25 0 0 1-2.25 2.25h-13.5A2.25 2.25 0 0 1 40 24v-6m18 0v-3m-18 3v-3m18 0a2.25 2.25 0 0 0-2.25-2.25h-13.5A2.25 2.25 0 0 0 40 15m18 0v-3a2.25 2.25 0 0 0-2.25-2.25h-13.5A2.25 2.25 0 0 0 40 12v3",
    stroke: "url(#b)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.26 48v-9.184h2.618c.69 0 1.293.084 1.806.252.513.168.915.453 1.204.854.29.392.434.924.434 1.596 0 .961-.313 1.675-.938 2.142-.625.467-1.442.7-2.45.7h-1.512V48H29.26Zm1.162-4.592h1.372c.803 0 1.395-.15 1.778-.448.392-.308.588-.789.588-1.442 0-.663-.205-1.12-.616-1.372-.401-.261-1.003-.392-1.806-.392h-1.316v3.654Zm7.722 4.76c-.57 0-1.045-.168-1.428-.504-.373-.345-.56-.821-.56-1.428 0-.747.331-1.316.994-1.708.672-.401 1.732-.681 3.178-.84 0-.29-.042-.565-.126-.826a1.184 1.184 0 0 0-.42-.63c-.196-.168-.48-.252-.854-.252-.392 0-.76.075-1.106.224-.345.15-.653.317-.924.504l-.448-.798a7.07 7.07 0 0 1 1.162-.588c.467-.196.97-.294 1.512-.294.83 0 1.433.257 1.806.77.373.504.56 1.18.56 2.03V48h-.952l-.098-.812h-.042c-.317.261-.667.49-1.05.686a2.552 2.552 0 0 1-1.204.294Zm.336-.924c.327 0 .635-.08.924-.238.29-.159.597-.383.924-.672v-1.89c-1.13.14-1.922.35-2.38.63-.448.28-.672.64-.672 1.078 0 .383.117.663.35.84.233.168.518.252.854.252Zm5.363 3.682c-.15 0-.294-.014-.434-.042a3.421 3.421 0 0 1-.364-.098l.224-.91c.075.019.159.037.252.056a.926.926 0 0 0 .266.042c.383 0 .7-.14.952-.42a2.79 2.79 0 0 0 .588-1.036l.154-.504-2.73-6.818h1.19l1.386 3.766c.102.29.21.602.322.938.121.336.233.663.336.98h.056c.103-.308.2-.63.294-.966.093-.336.187-.653.28-.952l1.218-3.766h1.12L46.39 48.56c-.159.448-.35.85-.574 1.204a2.502 2.502 0 0 1-.812.84c-.318.215-.705.322-1.162.322Zm9.114-2.758a3.06 3.06 0 0 1-1.554-.42c-.476-.28-.863-.686-1.162-1.218-.29-.532-.434-1.171-.434-1.918 0-.765.145-1.414.434-1.946.299-.532.686-.938 1.162-1.218a3.06 3.06 0 0 1 1.554-.42c.56 0 1.078.14 1.554.42.476.28.859.686 1.148 1.218.299.532.448 1.18.448 1.946 0 .747-.15 1.386-.448 1.918-.29.532-.672.938-1.148 1.218a3.01 3.01 0 0 1-1.554.42Zm0-.952c.588 0 1.06-.238 1.414-.714.364-.485.546-1.115.546-1.89 0-.784-.182-1.419-.546-1.904-.354-.485-.826-.728-1.414-.728-.578 0-1.05.243-1.414.728-.364.485-.546 1.12-.546 1.904 0 .775.182 1.405.546 1.89.364.476.836.714 1.414.714Zm7.03.952c-.718 0-1.246-.224-1.582-.672-.336-.457-.504-1.12-.504-1.988v-4.312h1.162v4.158c0 .635.098 1.097.294 1.386.206.29.532.434.98.434.355 0 .667-.089.938-.266.28-.187.579-.48.896-.882v-4.83h1.148V48h-.952l-.098-1.064h-.042a4.467 4.467 0 0 1-1.008.896 2.258 2.258 0 0 1-1.232.336Zm7.87 0c-.729 0-1.237-.21-1.527-.63-.28-.42-.42-.966-.42-1.638v-3.766h-1.008v-.868l1.064-.07.14-1.904h.966v1.904h1.834v.938h-1.834v3.78c0 .42.075.747.224.98.16.224.434.336.826.336.122 0 .252-.019.392-.056l.378-.126.224.868a4.894 4.894 0 0 1-.616.168c-.214.056-.429.084-.644.084Z",
    fill: "#F48FFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 49,
    y1: 0,
    x2: 49,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE91FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 49,
    y1: 9.75,
    x2: 49,
    y2: 26.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AC7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE92FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayout);
export default __webpack_public_path__ + "static/media/payout.55835eeeb5174e0e275507cfb47f1b19.svg";
export { ForwardRef as ReactComponent };